export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    fontSecondaryFamily: React.CSSProperties['fontFamily'];
    fontWeightSemiBold: React.CSSProperties['fontWeight'];
  }
}

export const primaryFont = 'Montserrat, sans-serif';
export const secondaryFont = 'Montserrat, sans-serif';

export const typography = {
  fontFamily: primaryFont,
  fontSecondaryFamily: secondaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,

  // Header-hbd
  'bold-hd-xl': {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(32),
  },
  'bold-hd-lg': {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(28),
  },
  'bold-hd-md': {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(25),
  },
  'bold-hd-sm': {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(22),
  },
  'bold-hd-xs': {
    fontWeight: 500,
    lineHeight: 1.2,
    fontSize: pxToRem(18),
  },

  // Bold-bd
  'bold-bd-lg': {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  'bold-bd-md': {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  'bold-bd-sm': {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  'bold-bd-xs': {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(10),
  },

  // Header
  'header-xl': {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(32),
  },
  'header-lg': {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(28),
  },
  'header-md': {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(25),
  },
  'header-sm': {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(22),
  },
  'header-xs': {
    fontWeight: 400,
    lineHeight: 1.2,
    fontSize: pxToRem(18),
  },

  // Body
  'body-lg': {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  'body-md': {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  'body-sm': {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  'body-xs': {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(10),
  },
} as const;
